import { Button } from "@fluentui/react-components";
import * as React from "react";
import { insertTextToActiveCell } from "../../taskpane";

interface InsertToCellProps {
  result: string | number;
  isDisabled: boolean;
}

const InsertToCell = (props: InsertToCellProps) => {
  return (
    <>
      <Button disabled={props.isDisabled} onClick={() => insertTextToActiveCell(props.result)}>
        Insert result
      </Button>
    </>
  );
};

export default InsertToCell;
